module.exports = __webpack_public_path__ + "assets/img/bg-dashboard.55bb845e.png";